export enum JobsStatus {
    // Synthetic — not a real DB status. Filters jobs whose `navn` contains "Hjelpepunkt".
    Hjelpepunkt = -2,
    Alle = -1,
    Ukjent = 0,
    Plan = 1,
    QA1 = 2,
    PlanIkkeGodkjent = 3,
    TilUtføring = 4,
    Utføres = 5,
    Utført = 6,
    QA2 = 7,
    TilKontroll = 8,
    JobbIkkeGodkjent = 9,
    Ferdig = 10,
    FailedSendingToSksd = 11,
    DataLastetOpp = 12,
    AnalyseStartet = 13,
    AnalyseGjennomfort = 14,
    AnalyseFeilet = 15,
    KontrollskjermingAvvik = 16,
}

export const jobStatusToString = (status: JobsStatus) => {
    switch (status) {
        case JobsStatus.Plan:
            return "Plan";
        case JobsStatus.QA1:
            return "QA1";
        case JobsStatus.PlanIkkeGodkjent:
            return "Plan Ikke Godkjent";
        case JobsStatus.TilUtføring:
            return "Til Utføring";
        case JobsStatus.Utføres:
            return "Utføres";
        case JobsStatus.Utført:
            return "Utført";
        case JobsStatus.QA2:
            return "QA2";
        case JobsStatus.TilKontroll:
            return "Til Kontroll";
        case JobsStatus.JobbIkkeGodkjent:
            return "Jobb Ikke Godkjent";
        case JobsStatus.Ferdig:
            return "Ferdig";
        case JobsStatus.FailedSendingToSksd:
            return "Feil ved sending til SKSD";
        case JobsStatus.Alle:
            return "Alle";
        case JobsStatus.Hjelpepunkt:
            return "Hjelpepunkt";
        case JobsStatus.DataLastetOpp:
            return "Data Lastet Opp";
        case JobsStatus.AnalyseStartet:
            return "Analyse Startet";
        case JobsStatus.AnalyseGjennomfort:
            return "Analyse Gjennomført";
        case JobsStatus.AnalyseFeilet:
            return "Analyse Feilet";
        case JobsStatus.KontrollskjermingAvvik:
            return "Kontrollskjerming Avvik";
        default:
            return "Ukjent";
    }
};

export const allJobsStatus = () => {
    return Object.keys(JobsStatus)
        .filter((key) => isNaN(Number(key)))
        .map((key) => {
            return JobsStatus[key as keyof typeof JobsStatus].toString();
        });
};

export enum JobsPanelState {
    LIST = "list",
    JOB = "job",
    NEW = "new",
    NEW_FOR_OBJECT = "new_for_object",
}

export enum JobsType {
    UNDEFINED = 0,
    CREATION = 1,
    MODIFICATION = 2,
    DISCONTINUATION = 3,
    REMOVAL = 4,
    SECTOR_CONTROL = 5,
    REPLACEMENT = 6,
    DRONE_CONTROL = 7,
}
